import React, { Component } from "react";
import {
  ChangePageDataSetState,
  ExecuteLayoutEventMethods,
  getProcessedArgs,
  getProcessedDynamic,
  objectMatchAll,
} from "../../../General/commonFunctions";
import ListViewBubbleTemplate from "../ControlTemplates/ListViewItem/listViewBubbleTemplate";
import ListViewCustomTemplate from "../ControlTemplates/ListViewItem/listViewCustomTemplate";
import { List } from "devextreme-react";

import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.css";
import { ownStore } from "../../../AppOwnState/ownState";
import { Pagination } from "@mui/lab";
import { appTheme } from "../../../General/globals";

class FactsDevList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentDS: this.filterDataset(this.getCurrentDataSet()),
      currentPage: 1,
    };
    this.divRef = React.createRef();
    this.searchExpr = getProcessedDynamic(props.searchExpr);
  }

  ripOffControlSpecificAttributes() {
    this.scrolldown = this.props.scrolldown;

    const excluded = [
      "scrolldown",
      "content",
      "datasets",
      "refData",
      "filterto",
      "reverse",
    ];
    return Object.keys(this.props)
      .filter((t) => !excluded.includes(t))
      .reduce((obj, key) => {
        obj[key] = this.props[key];
        return obj;
      }, {});
  }

  getCurrentDataSet() {
    let listds = ChangePageDataSetState(this.props.datasets);
    if (!listds) return null;
    if (this.props.reverse && Array.isArray(listds)) listds = listds.reverse();

    return listds[this.props.datasets[0]];
  }

  filterDataset(listData) {
    if (this.props.filterto && listData) {
      let filterTo = getProcessedArgs(this.props.filterto, this.props.refData);
      if (filterTo) {
        return listData.filter((it) => {
          return objectMatchAll(it, filterTo);
        });
      } else return listData;
    } else return listData;
  }

  componentDidMount() {
    this.mounted = true;

    if (this.props.datasets && this.props.datasets.length > 0) {
      this.setState({
        currentDS: this.getCurrentDataSet(),
      });

      this.unsubscribe = ownStore.subscribe((storeInfo) => {
        if (this.mounted) {
          if (
            this.props.datasets[0] === storeInfo.dset ||
            this.props.datasets[0] === "this" ||
            this.props.watch?.includes(storeInfo.dset)
          ) {
            let newDS = this.getCurrentDataSet();

            this.setState({
              currentDS: this.filterDataset(newDS),
              currentPage: 1,
            });
            this.scrollToDown();
          }
        }
        // }
      });
    }
  }

  scrollToDown() {
    if (this.scrolldown === true) {
      setTimeout((t) => {
        if (this.divRef?.current?.lastChild) {
          this.divRef.current.lastChild.scrollIntoView({ block: "start" });
        } else this.scrollToDown();
      }, 25);
    }
  }

  handlepagechange = async (e, v) => {
    const currentPage = v;
    const rowsPerPage = 20;

    await ExecuteLayoutEventMethods([
      {
        exec: "setdataset",
        args: {
          dset: "DevListPaginationState",
          data: {
            currentPage,
            rowsPerPage,
          },
        },
      },
    ]);

    const theState = ownStore.getState("DevListPaginationState");
    return theState;
  };

  componentWillUnmount() {
    // alert('unmounted')

    this.scrolldown = false;
    if (this.unsubscribe) this.unsubscribe();
    this.mounted = false;
  }

  handleOnContentReady(e) {
    if (this.props?.autoFocusOnSearch == true) {
      e.component.element().querySelector("input")?.focus();
    }

    ExecuteLayoutEventMethods(this.props?.whencontentready, {
      ...this.props.refData,
      ...this.props,
    });
  }

  render() {
    let newProps = this.ripOffControlSpecificAttributes();
    let listArrayToRender = this.convertToArrayIfObject(this.state.currentDS);
    let index = 0;
    let pageCount = 0;
    let pageSize = parseInt(this.props.pagesize);
    if (isNaN(pageSize)) pageSize = 0;
    let pagelistArray = listArrayToRender;
    if (pageSize > 0) {
      pageCount =
        this.props.dataLength ??
        Math.ceil(listArrayToRender?.length / pageSize);

      let fromItem = (this.state.currentPage - 1) * pageSize;
      let toItem = fromItem + pageSize;

      pagelistArray = listArrayToRender?.slice(fromItem, toItem);
    }
    return (
      <>
        <List
          className="factsDevList"
          rtlEnabled={appTheme.direction === "rtl"}
          searchExpr={this.searchExpr}
          focusStateEnabled={true}
          activeStateEnabled={true}
          selectionMode="single"
          dataSource={pagelistArray}
          noDataText={
            appTheme.direction === "rtl"
              ? "لا توجد بيانات لعرض"
              : "No data to display"
          }
          searchEditorOptions={{
            placeholder: appTheme.direction === "rtl" ? "بحث" : "Search",
          }}
          onPullRefresh={(e) => {
            ExecuteLayoutEventMethods(e.props?.onPullRefreshEvent);
          }}
          onContentReady={(e) => this.handleOnContentReady(e)}
          itemRender={(it) => {
            let templ = this.getContentTemplate(
              this.props.content,
              {
                propkey: it.propkey ?? index,
                proptype: this.getValueType(it),
                ...it,
              },
              index
            );
            index++;

            return templ;
          }}
          {...newProps}
          onSelectionChanged={(e) => {
            if (e.addedItems.length) {
              const selectedItem = e.addedItems[0];

              const matchedElements = Array.from(
                e.element.querySelectorAll(".lkupListContent")
              ).filter(
                (item) =>
                  item?.innerText.trim() === selectedItem?.description?.trim()
              );

              if (matchedElements.length > 0) {
                matchedElements[0].click();

                const lastFocusOn = ownStore.getState("GDSfocusElement")
                  ?.element;

                const element = document.querySelectorAll(`.${lastFocusOn}`);
              }
              ExecuteLayoutEventMethods(this.props?.onItemSelected, {
                ...this.props.refData,
                selectedItem,
              });
            }
          }}
        />

        {pageCount > 0 && (
          <Pagination
            className="DevListPagination"
            style={{
              backgroundColor: "#fcfcfc",
              padding: "10px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            count={pageCount}
            showLastButton
            showFirstButton
            {...newProps?.pageprops}
            whenchange={undefined}
            page={this.state.currentPage}
            onChange={(e, v) => {
              this.handlepagechange(e, v);
              this.setState({ currentPage: v });
              ExecuteLayoutEventMethods(newProps?.pageprops?.whenchange, {
                ...this.props.refData,
                currentPage: v,
              });
            }}
          />
        )}
      </>
    );
  }

  convertToArrayIfObject(currentList) {
    if (currentList && !Array.isArray(currentList)) {
      return Object.keys(this.state.currentDS).map((t) => {
        return {
          propkey: t,
          propval: currentList[t],
          proptype: this.getValueType(currentList[t]),
        };
      });
    }

    return currentList;
  }

  getValueType(val) {
    if (val === null) return "null";
    if (typeof val === "string") return "string";
    if (typeof val === "boolean") return "boolean";
    if (typeof val === "object") {
      if (Array.isArray(val)) return "array";
      else return "object";
    }
  }

  getContentTemplate(content, item, index) {
    switch (content.template) {
      case "lvibubble":
        return (
          <ListViewBubbleTemplate
            key={index}
            {...content.props}
            itemObject={item}
          />
        );

      case "custom":
        return (
          <ListViewCustomTemplate
            key={index}
            itemProps={content.props}
            layout={content.chld}
            itemObject={item}
          />
        );
      default:
        return <div {...content.props} />;
    }
  }
}

export default React.memo(FactsDevList);
